import { Box, Divider, Grid, Typography } from '@mui/material';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

/** TRANSLATION*/
import HeaderLabel from 'component/CardCustom/HeaderLabel';
import { useTranslation } from 'react-i18next';

/** STYLE */


/** API */
import LoginApi from 'api/login-api';

/** UTILS || SLICE */
import { PACKAGE_ADDONS } from 'constants/package';
import { PickRoom, colors } from 'constants/theme';
import { checkPackage, getApp, numberOnly } from 'utils/app.utils';

/** CONSTANT */
import AboutUs from 'api/admin/clinic-manage/about.api';
import ServicePointApi from 'api/setting/branch-service-points/service-point.api';
import Loading from 'component/Loading';
import { notiError, notiSuccess } from 'component/notifications/notifications';
import { menuFirsts, menuSeconds, menuThirds } from 'constants/menus';
import CheckboxButton from 'new-components/buttons/checkbox-button';
import RadioButton from 'new-components/buttons/radio-button';
import SwitchButton from 'new-components/buttons/switch-button';
import TextInput from 'new-components/inputs/text-input';
import { routeName } from 'routes/routes-name';


const initStateErrorMessage = {
  SERVICE_POINT_NAME: '',
  IS_DUPLICATE_SERVICE_POINT_NAME: '',
  SERVICE_POINT_NAME_STRING_BASE: '',
  SERVICE_POINT_NAME_STRING_EMPTY: '',
  SERVICE_POINT_NAME_MAXIMUM_LENGTH: '',
  SERVICE_POINT_NAME_ANY_REQUIRED: '',
  SORTING_REQUIRED: '',
  IS_DUPLICATE_SORTING: '',
  IS_DUPLICATE_SERVICE_POINT_NAME_EN: ''
}

const initStateEditMenu = {
  createdAt: '',
  createdBy: '',
  pointOfService: 'ROOMSERVICES',
  servicePointId: '',
  servicePointMenus: [
    {
      menuFirstId: 0,
      menuSecondId: 0,
      menuThirdId: 0
    }
  ],
  servicePointName: '',
  servicePointNameEn: '',
  status: '',
  sorting: null,
  updatedAt: '',
  updatedBy: ''
}

interface MenuSelectInterface {
  menuFirstId: number
  menuSecondId: number | null
  menuThirdId: number | null
}

export default function FormServicePoint() {
  const location = useLocation()
  const history = useHistory()
  const { t } = useTranslation()

  const [loading, setLoading] = useState(false)
  const [initLocation, setInitLocation] = useState({})
  const [menus, setMenu] = useState<any>([])
  const [allMenus, setAllMenu] = useState<MenuSelectInterface[] | []>([])
  const [servicePointId, setServicePointId] = useState(Number)
  const [servicePointName, setServicePointName] = useState('')
  const [servicePointNameEn, setServicePointNameEn] = useState('')
  const [sorting, setSorting] = useState<any | null>(null);
  const [pointOfService, setPointOfService] = useState('ROOMSERVICES')
  const [statusServicePoint, setStatusServicePoint] = useState('ACTIVE')
  const [indeterminate, setIndeterminate] = useState(false)
  const [checkAll, setCheckAll] = useState(false)


  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)
  const [editMenu, setEditMenu] = useState(initStateEditMenu)
  const [menuSelects, setMenuSelects] = useState<MenuSelectInterface[] | []>([])

  const [loadingPermiss, setLoadingPermiss] = useState<boolean>(false)
  const [permissClinic, setPermissClinic] = useState<any>({})

  // const res = await AboutUs.findAboutUs();

  const loadPermissClinic = async () => {
    setLoadingPermiss(true)
    const res = await AboutUs.findAboutUs().finally(() => setLoadingPermiss(false))
    setPermissClinic(res?.data || {})
  }

  useEffect(() => {
    setLoading(true)
    loadPermissClinic()
    LoginApi.menus().then(({ data }) => {
      if (data) {
        initRender(data)
      }
    })
    setInitLocation(location)
    const { state }: any = initLocation
    setEditMenu(state)
    setTimeout(function () {
      if (editMenu) onEdit()
      setLoading(false)
    }, 1000)
  }, [location, editMenu])

  // เมื่อ location เปลี่ยน ให้ setEditMenu
  useEffect(() => {
    setInitLocation(location)
    const { state }: any = location
    if (state) setEditMenu(state)
  }, [location])

  // เมื่อ editMenu เปลี่ยน ให้ onEdit
  useEffect(() => {
    if (editMenu) onEdit()
  }, [editMenu])

  const initRender = (menusRender: any) => {
    const menuAll: { menuFirstId: any; menuSecondId: any; menuThirdId: any }[] = []
    const tempFirstSelect: any = []
    const tempSecondSelect: any = []
    const tempThirdSelect: any = []

    setMenu(menusRender)

    for (const keyFirst in menusRender) {
      if (Object.prototype.hasOwnProperty.call(menusRender, keyFirst)) {
        const menuFirst = menusRender[keyFirst]
        menuAll.push({
          menuFirstId: menuFirst.menuFirstId,
          menuSecondId: null,
          menuThirdId: null
        })
        if (menuFirst.menuSeconds.length) {
          for (const keySecond in menuFirst.menuSeconds) {
            if (Object.prototype.hasOwnProperty.call(menuFirst.menuSeconds, keySecond)) {
              const menuSecond = menuFirst.menuSeconds[keySecond]

              if (menuSecond.menuThirds.length)
                for (const keyThird in menuSecond.menuThirds) {
                  if (Object.prototype.hasOwnProperty.call(menuSecond.menuThirds, keyThird)) {
                    const menuThird = menuSecond.menuThirds[keyThird]
                    menuAll.push({
                      menuFirstId: menuFirst.menuFirstId,
                      menuSecondId: menuSecond.menuSecondId,
                      menuThirdId: menuThird.menuThirdId
                    })
                    tempThirdSelect[menuThird.menuThirdId] = false
                  }
                }
              else {
                menuAll.push({
                  menuFirstId: menuFirst.menuFirstId,
                  menuSecondId: menuSecond.menuSecondId,
                  menuThirdId: null
                })
                tempSecondSelect[menuSecond.menuSecondId] = false
              }
            }
          }
        } else {
          tempFirstSelect[menuFirst.menuFirstId] = false
        }
      }
    }

    setAllMenu(menuAll)
    setLoading(false)
  }

  const onEdit = () => {
    const { servicePointId: servicePointIdData, servicePointName: servicePointNameData, servicePointNameEn: servicePointNameEnData, pointOfService: servicePointOfService, sorting: servicePointSorting, status: servicePointStatus } = editMenu

    setServicePointId(Number(servicePointIdData))
    setServicePointName(servicePointNameData)
    setServicePointNameEn(servicePointNameEnData)
    setStatusServicePoint(servicePointStatus)
    setPointOfService(servicePointOfService)
    setSorting(servicePointSorting)

    if (editMenu.servicePointMenus.length) setMenuSelects(editMenu.servicePointMenus?.map((spm: any) => ({ menuFirstId: spm.menuFirstId, menuSecondId: spm.menuSecondId, menuThirdId: spm.menuThirdId })))
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const submit = () => {
    if (!pointOfService) return setErrorMessage({ ...errorMessage, ...{ POINT_OF_SERVICE: t(`SERVICE_POINT.MESSAGE.POINT_OF_SERVICE`) } })
    if (!servicePointName || !pointOfService || (!sorting && sorting !== 0)) {
      return setErrorMessage({
        ...errorMessage,
        SERVICE_POINT_NAME: !servicePointName ? t(`SERVICE_POINT.MESSAGE.SERVICE_POINT_NAME`) : '',
        SORTING_REQUIRED: !sorting && sorting !== 0 ? t(`SERVICE_POINT.MESSAGE.SORTING_REQUIRED`) : ''
      })
    }

    const servicePointMenus = menuSelects

    setLoading(true)

    const objCreate = {
      servicePointName: servicePointName,
      servicePointNameEn: servicePointNameEn,
      pointOfService: pointOfService,
      servicePointMenus: servicePointMenus,
      sorting: sorting
    }

    const hasRoleMenu: boolean = _.some(servicePointMenus, (menu) => menu.menuFirstId > 0)
    if (!hasRoleMenu) {
      setLoading(false)
      return notiError(t('SERVICE_POINT.MESSAGE.NO_SELECT_ROLE_MENUS'))
    }

    ServicePointApi.create(objCreate)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t(`SERVICE_POINT.MESSAGE.SUCCESS.CREATE`), '', null, () => {

            return
          })
          history.push(routeName.servicePoint)
        }
        else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`SERVICE_POINT.MESSAGE.${err.message}`) } })
          if (err.message === 'IS_DUPLICATE_POINTOFSERVICE') return notiError(t('SERVICE_POINT.MESSAGE.IS_DUPLICATE_POINT_OF_SERVICE'))
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`SERVICE_POINT.MESSAGE.${err.message}`) } })
        if (err.message === 'IS_DUPLICATE_POINTOFSERVICE') return notiError(t('SERVICE_POINT.MESSAGE.IS_DUPLICATE_POINT_OF_SERVICE'))
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const submitUpdate = () => {
    if (!pointOfService) return setErrorMessage({ ...errorMessage, ...{ POINT_OF_SERVICE: t(`SERVICE_POINT.MESSAGE.POINT_OF_SERVICE`) } })
    if (!servicePointName || !pointOfService || (!sorting && sorting !== 0)) {
      return setErrorMessage({
        ...errorMessage,
        SERVICE_POINT_NAME: !servicePointName ? t(`SERVICE_POINT.MESSAGE.SERVICE_POINT_NAME`) : '',
        SORTING_REQUIRED: !sorting && sorting !== 0 ? t(`SERVICE_POINT.MESSAGE.SORTING_REQUIRED`) : ''
      })
    }
    setLoading(true)

    const servicePointMenus = menuSelects
    const objUpdate = {
      servicePointName: servicePointName,
      servicePointNameEn: servicePointNameEn,
      pointOfService: pointOfService,
      servicePointMenus: servicePointMenus,
      status: statusServicePoint,
      sorting: sorting
    }

    const hasRoleMenu: boolean = _.some(servicePointMenus, (menu) => menu.menuFirstId > 0)
    if (!hasRoleMenu) {
      setLoading(false)
      return notiError(t('SERVICE_POINT.MESSAGE.NO_SELECT_ROLE_MENUS'))
    }

    ServicePointApi.update(servicePointId, objUpdate)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`SERVICE_POINT.MESSAGE.SUCCESS.UPDATE`), '', null, () => {
            return
          })
          history.push(routeName.servicePoint)
        }
        else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`SERVICE_POINT.MESSAGE.${err.message}`) } })
          if (err.message === 'IS_DUPLICATE_POINTOFSERVICE') return notiError(t('SERVICE_POINT.MESSAGE.IS_DUPLICATE_POINT_OF_SERVICE'))
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`SERVICE_POINT.MESSAGE.${err.message}`) } })
        if (err.message === 'IS_DUPLICATE_POINTOFSERVICE') return notiError(t('SERVICE_POINT.MESSAGE.IS_DUPLICATE_POINT_OF_SERVICE'))
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleCheckAll = (e: any) => {
    const checked: boolean = e.target.checked

    setIndeterminate(false)
    setCheckAll(checked)
    if (checked) setMenuSelects(_.map(allMenus, (am) => am))
    else setMenuSelects([])

  }

  useEffect(() => {
    setCheckAll(allMenus.length === menuSelects.length)

    _.map(Object.keys(_.groupBy(menuSelects, 'menuFirstId')), (fId: number) => {
      const filterMs: MenuSelectInterface[] = _.filter(menuSelects, (ms: MenuSelectInterface) => String(ms.menuFirstId) === String(fId))
      const countMs: number = filterMs.length
      const findMenu: any = _.find(menus, (menu: any) => String(menu.menuFirstId) === String(fId))
      if (findMenu !== undefined)
        if (findMenu.menuSeconds.length > 0) {
          const countChecked: number = _.filter(filterMs, (fMs: MenuSelectInterface) => fMs.menuSecondId !== null).length
          const obj: any = { menuFirstId: Number(fId), menuSecondId: null, menuThirdId: null }
          if (countChecked) {
            if (countMs === countChecked) setMenuSelects([...menuSelects, obj])
          } else setMenuSelects([..._.filter(menuSelects, (ms: MenuSelectInterface) => JSON.stringify(ms) !== JSON.stringify(obj))])
        }
    })
  }, [menuSelects])

  const handleCheckMenu = (e: any, value: MenuSelectInterface) => {
    const checked: boolean = e?.target?.checked || false
    const { menuFirstId, menuSecondId, menuThirdId }: MenuSelectInterface = value

    const arrVal: any = []
    const menuFirst: any = _.find(menus, (menu: any) => menu.menuFirstId === menuFirstId)
    if (menuFirst) {
      const { menuFirstId, menuSeconds } = menuFirst
      const menuSecond: any = _.find(menuSeconds, (data: any) => data.menuSecondId === menuSecondId)
      if (!menuSecond)
        _.map(menuSeconds, (data: any) => {
          const { menuSecondId, menuThirds } = data
          const valSecond: MenuSelectInterface = { menuFirstId, menuSecondId, menuThirdId: null }
          arrVal.push(valSecond)

          const menuThird: any = _.find(menuThirds, (dataMenuThirds: any) => dataMenuThirds.menuThirdId === menuThirdId)
          if (!menuThird)
            _.map(menuThirds, (dataMenuThirds: any) => {
              const { menuThirdId } = dataMenuThirds
              const valThird: MenuSelectInterface = { menuFirstId, menuSecondId, menuThirdId }
              arrVal.push(valThird)
            })

        })
    }

    const insertVal: any[] = _.map([value, ...arrVal], (ms: MenuSelectInterface) => JSON.stringify(ms))

    if (checked) {
      setMenuSelects([...menuSelects, value, ...arrVal])
    } else {

      setMenuSelects(menuSelects.filter((ms: MenuSelectInterface) => !insertVal.includes(JSON.stringify(ms))))
    }
  }

  const checkSelect = (value: MenuSelectInterface) => (menuSelects.find((ms: MenuSelectInterface) => ms.menuFirstId === value.menuFirstId && ms.menuSecondId === value.menuSecondId && ms.menuThirdId === value.menuThirdId) ? true : false)

  return (
    <Box height="100%" sx={{ overflow: 'hidden' }}>
      <Box height="100%" display="flex" flexDirection="column">
        <HeaderLabel
          text={servicePointId ? t('SERVICE_POINT.TITLE_UPDATE') : t('SERVICE_POINT.TITLE_CREATE')}
          goBack={routeName.servicePoint}
          disabledSend={loading}
          onSubmit={servicePointId ? submitUpdate : submit}
          navigator={{ previousTo: routeName.servicePoint, previousTitle: t('SERVICE_POINT.TITLE'), currentTitle: servicePointId ? t('SERVICE_POINT.TITLE_UPDATE') : t('SERVICE_POINT.TITLE_CREATE') }}
        />
        <Box border="1px solid" borderColor={colors.lightGray} boxShadow={1} mx={4} mb={4} height="100%" overflow="hidden" borderRadius={2} bgcolor="#fff">
          <Box height="100%" py={0} pl={2} pr={3} overflow="hidden" display="flex" flexDirection="column" >
            <Grid container spacing={1} className={'h-100 mt-0'}>
              <Grid item lg={2} className={'w-100 pr-lg-2 border-right'} sx={{ borderRight: { lg: `1px solid ${colors.lightGray}` } }}>
                <Box height="100%" sx={{ overflow: 'hidden' }}>
                  <Box border={`1px solid ${colors.lightGray}`} width="100%" p={4} textAlign="center" sx={{ mt: 0, mb: 4 }}>
                    <Box
                      width={{ xs: '30%', lg: '60%' }}
                      maxWidth={100}
                      mx="auto"
                      position="relative"
                      sx={{
                        '& .MuiBox-root': {
                          paddingTop: '100%',
                          '& svg': {
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                          },
                        },
                      }}
                    >
                      <Box width="100%">
                        {(pointOfService === 'COUNTER' && <PickRoom.Counter color={colors.themeMainColor} />) ||
                          (pointOfService === 'PAYMENT' && <PickRoom.Payment color={colors.themeMainColor} />) ||
                          (pointOfService === 'ROOMSERVICES' && <PickRoom.Service color={colors.themeMainColor} />) ||
                          <PickRoom.OtherService color={colors.themeMainColor} />}
                      </Box>
                    </Box>
                    <Typography sx={{ fontSize: 18, fontWeight: 500, color: colors.themeMainColor }}>{t(`SERVICE_POINT.${pointOfService}`)}</Typography>
                  </Box>
                  {servicePointId ? (
                    <Box mt={2}>
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
                        <SwitchButton onChange={() => setStatusServicePoint(statusServicePoint === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={statusServicePoint === 'ACTIVE'} />
                      </Box>
                      <Divider sx={{ display: { xl: 'none' }, my: 3, backgroundColor: 'transparent', borderColor: `${colors.lightGray} !important`, }} />
                    </Box>
                  ) : (<></>)}
                </Box>
              </Grid>
              <Grid item xs={12} lg={10} sx={{ width: '100%', pl: { lg: 4 }, height: '100%', overflow: 'auto' }} >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item sm={6} lg={3} sx={{ width: '100%' }}>
                        <TextInput
                          label={t('SERVICE_POINT.INPUT.SERVICE_POINT_NAME')}
                          value={servicePointName}
                          onChange={(event) => {
                            setServicePointName(event.target.value)
                            clearErrorMessage()
                          }}
                          helperText={
                            errorMessage.SERVICE_POINT_NAME ||
                            errorMessage.IS_DUPLICATE_SERVICE_POINT_NAME ||
                            errorMessage.SERVICE_POINT_NAME_STRING_BASE ||
                            errorMessage.SERVICE_POINT_NAME_STRING_EMPTY ||
                            errorMessage.SERVICE_POINT_NAME_MAXIMUM_LENGTH ||
                            errorMessage.SERVICE_POINT_NAME_ANY_REQUIRED
                          }
                          required
                          fullWidth
                        />
                      </Grid>
                      <Grid item sm={6} lg={3} sx={{ width: '100%' }}>
                        <TextInput
                          label={t('SERVICE_POINT.INPUT.SERVICE_POINT_NAME_EN')}
                          helperText={errorMessage.IS_DUPLICATE_SERVICE_POINT_NAME_EN}
                          value={servicePointNameEn}
                          onChange={(e) => setServicePointNameEn(e.target.value)}
                          fullWidth
                        />
                      </Grid>
                      <Grid item sm={6} lg={3} sx={{ width: '100%' }}>
                        <TextInput
                          label={t('SERVICE_POINT.INPUT.SORT')}
                          value={sorting}
                          required
                          onChange={(e) => {
                            setSorting(numberOnly(e) || '')
                            clearErrorMessage()
                          }}
                          helperText={
                            errorMessage.SORTING_REQUIRED ||
                            errorMessage.IS_DUPLICATE_SORTING
                          }
                          fullWidth
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: 'flex',
                      justifyContent: { xs: 'space-between', sm: 'flex-start' },
                      ml: 1,
                    }}
                  >
                    <Box mr={2} display="flex" alignItems="center">
                      <RadioButton
                        name="point-of-service"
                        value={pointOfService}
                        onChange={(event) => setPointOfService(event.target.value)}
                        row
                        options={[
                          { label: t('SERVICE_POINT.COUNTER'), value: 'COUNTER' },
                          { label: t('SERVICE_POINT.PAYMENT'), value: 'PAYMENT' },
                          { label: t('SERVICE_POINT.ROOMSERVICES'), value: 'ROOMSERVICES' },
                          { label: t('SERVICE_POINT.SERVICES'), value: 'SERVICES', tooltip: t('SERVICE_POINT.MESSAGE.SERVICE_NOT_VISIBLE') }
                        ]}
                      />
                    </Box>
                  </Grid>
                </Grid>
                <Divider
                  sx={{
                    mt: 2,
                    backgroundColor: 'transparent',
                    borderColor: `${colors.lightGray} !important`,
                  }}
                />
                <Typography my={3} sx={{ fontSize: 18, fontWeight: 500 }}>
                  {t('SERVICE_POINT.MENU_PERMISSION')}
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} width={'100%'}>
                    <Box pl={2}>
                      <CheckboxButton key={'check-all'} label={t('SERVICE_POINT.SELECT_ALL')} checked={checkAll} indeterminate={indeterminate} onChange={handleCheckAll} />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sx={{ width: '100%' }}>
                    <Grid
                      container
                      spacing={2}
                      sx={{
                        pb: 4,
                        '.divider-backend-menu': {
                          display: 'none',
                          '&:not(.divider-backend-menu ~ .divider-backend-menu).divider-backend-menu':
                            { display: 'block' },
                        },
                      }}>
                      {_.map(_.sortBy(menus, ['menuFirstSorting']), ({ menuFirstId, menuFirstKey, menuSeconds: mSnds, menuFirstTags }: any, indexFirstKeyNumber: number) => {
                        if (menuFirstKey !== 'CLINIC_MANAGEMENT' && checkPackage(_.includes(PACKAGE_ADDONS, menuFirstKey) ? menuFirstKey : ''))

                          return (
                            <>
                              {menuFirstTags === 'BACKEND' && (
                                <Grid
                                  item xs={12}
                                  key={indexFirstKeyNumber}
                                  className={'w-100 divider-backend-menu'}>
                                </Grid>
                              )}
                              {mSnds.length === 0 ? (
                                <Grid item md={6} key={menuFirstId} sx={{ width: '100%', display: 'flex', flexDirection: 'column' }} >
                                  <Box sx={{ pl: 2, mb: 'auto', backgroundColor: colors.themeSecondColor10, fontSize: '18px' }}>
                                    <CheckboxButton
                                      key={menuFirstId}
                                      label={menuFirsts[menuFirstKey]
                                        ? t(menuFirsts[menuFirstKey].textName)
                                        : 'NO_Name'}
                                      checked={checkSelect({ menuFirstId, menuSecondId: null, menuThirdId: null })}
                                      onChange={e =>
                                        handleCheckMenu(e, { menuFirstId, menuSecondId: null, menuThirdId: null })
                                      }
                                    />
                                  </Box>
                                  <Divider className={`mx-0 mt-2 ${indexFirstKeyNumber + 2 >= menus.length ? 'd-none' : ''}`} sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                                </Grid>
                              ) : (

                                [
                                  <Grid item md={6} key={menuFirstId} sx={{ width: '100%', display: 'flex', flexDirection: 'column' }} >
                                    <Box sx={{ pl: 2, display: 'flex', alignItems: 'center', height: '42px', backgroundColor: colors.themeSecondColor10 }} >
                                      <CheckboxButton
                                        label={
                                          menuFirsts[menuFirstKey]
                                            ? t(menuFirsts[menuFirstKey].textName)
                                            : 'NO_Name'
                                        }
                                        checked={checkSelect({ menuFirstId, menuSecondId: null, menuThirdId: null })}
                                        onChange={e =>
                                          handleCheckMenu(e, { menuFirstId, menuSecondId: null, menuThirdId: null })
                                        }
                                      />
                                    </Box>

                                    <Grid container spacing={1} key={menuFirstId} sx={{ mt: 1, mb: 'auto' }}>
                                      {_.map(
                                        _.sortBy(mSnds, ['menuSecondSorting']),
                                        ({ menuSecondId, menuSecondKey, menuThirds: mTrds }, indexSecound) => {
                                          const isCheckApp =
                                            menuSeconds[menuSecondKey]?.key === 'APPLICATION'
                                              ? getApp() === 'PERMISS' && permissClinic?.enableApp === '1'
                                              : true;
                                          const isCheckWeb =
                                            menuSeconds[menuSecondKey]?.key === 'WEB_MANAGE'
                                              ? permissClinic?.useWeb === '1'
                                              : true;
                                          const isCheckCrm =
                                            menuSeconds[menuSecondKey]?.key === 'CRM_MANAGE'
                                              ? permissClinic?.useCrm === '1'
                                              : true;

                                          if (['CHECKIN'].includes(menuSeconds[menuSecondKey]?.key)) return;
                                          if (
                                            checkPackage(
                                              _.includes(PACKAGE_ADDONS, menuSecondKey) ? menuSecondKey : ''
                                            ) &&
                                            menuSeconds[menuSecondKey] &&
                                            isCheckApp &&
                                            isCheckWeb &&
                                            isCheckCrm
                                          ) {

                                            if (mTrds.length === 0) {
                                              return (
                                                <Grid item sm={6} key={menuSecondId} sx={{ width: '100%', display: 'flex', flexDirection: 'column', padding: { xl: '0 32px !important' } }}>
                                                  {!['TREATMENT_RIGHT'].includes(
                                                    menuSeconds[menuSecondKey]?.key
                                                  ) ? (
                                                    <Box sx={{ mb: 'auto', ml: 2 }}>
                                                      <CheckboxButton
                                                        key={menuSecondId}
                                                        label={
                                                          menuSeconds[menuSecondKey]
                                                            ? t(menuSeconds[menuSecondKey].textName)
                                                            : 'NO_Name'
                                                        }
                                                        checked={checkSelect({
                                                          menuFirstId,
                                                          menuSecondId,
                                                          menuThirdId: null
                                                        })}
                                                        onChange={e =>
                                                          handleCheckMenu(e, {
                                                            menuFirstId,
                                                            menuSecondId,
                                                            menuThirdId: null
                                                          })
                                                        }
                                                      />
                                                    </Box>
                                                  ) : (
                                                    <Box sx={{ mb: 'auto' }}>
                                                      <Typography
                                                        sx={{
                                                          mt: 1,
                                                          mb: 1,
                                                          color: colors.themeMainColor,
                                                          fontWeight: 500
                                                        }}
                                                      >
                                                        {menuSeconds[menuSecondKey]
                                                          ? t(menuSeconds[menuSecondKey].textName)
                                                          : 'NO_Name'}
                                                      </Typography>
                                                      <Box sx={{ padding: { xl: '0 16px !important' } }}>
                                                        <Grid container spacing={1}>
                                                          <Grid item md={12} sx={{ width: '100%', ml: 2 }}>
                                                            <CheckboxButton
                                                              key={menuSecondKey}
                                                              label={
                                                                menuSeconds[menuSecondKey]
                                                                  ? t(menuSeconds[menuSecondKey].textName)
                                                                  : 'NO_Name'
                                                              }
                                                              checked={checkSelect({
                                                                menuFirstId,
                                                                menuSecondId,
                                                                menuThirdId: null
                                                              })}
                                                              onChange={e =>
                                                                handleCheckMenu(e, {
                                                                  menuFirstId,
                                                                  menuSecondId,
                                                                  menuThirdId: null
                                                                })
                                                              }
                                                            />
                                                          </Grid>
                                                        </Grid>
                                                      </Box>
                                                    </Box>
                                                  )}
                                                  {menuFirsts[menuFirstKey]?.name === 'Setting' && (
                                                    <Divider sx={{ mx: 0, mt: 2, mb: 3, backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                                                  )}
                                                </Grid>
                                              );
                                            }

                                            if (menuSeconds[menuSecondKey]?.key === 'USAGE_APPROVAL_MANAGEMENT') {
                                              return (
                                                <Grid item xs={12} sm={menuFirsts[menuFirstKey]?.name === 'Setting' ? 6 : 12} key={menuSecondId}
                                                  sx={{ width: '100%', display: 'flex', flexDirection: 'column', padding: { xl: '0 32px !important' }, '&:last-child hr': { display: 'none' } }}>
                                                  <Box sx={{ mb: 'auto' }}>
                                                    <Typography sx={{ mt: 1, mb: 1, color: colors.themeMainColor, fontWeight: 500 }} >
                                                      {menuSeconds[menuSecondKey]
                                                        ? t(`${menuSeconds[menuSecondKey].textName}_OTHER`)
                                                        : 'NO_Name'}
                                                    </Typography>
                                                    <Box sx={{ padding: { xl: '0 16px !important' } }}>
                                                      <Grid container spacing={1}>
                                                        {_.map(
                                                          [
                                                            menus[indexFirstKeyNumber]?.menuSeconds?.find(
                                                              (i: any) => i?.menuSecondKey === 'CHECKIN'
                                                            ),
                                                            ..._.sortBy([...mTrds], ['menuThirdSorting'])
                                                          ],
                                                          ({
                                                            menuThirdId,
                                                            menuThirdKey,
                                                            menuSecondId: msId,
                                                            menuSecondKey: msKey
                                                          }) => {
                                                            if (
                                                              msKey &&
                                                              checkPackage(
                                                                _.includes(PACKAGE_ADDONS, msKey) ? msKey : ''
                                                              )
                                                            ) {
                                                              return (
                                                                <Grid item key={msKey} md={6} sx={{ width: '100%', label: { ml: 0 } }} >
                                                                  <CheckboxButton
                                                                    key={msKey}
                                                                    label={
                                                                      menuSeconds[msKey]
                                                                        ? t(menuSeconds[msKey].textName)
                                                                        : 'NO_Name'
                                                                    }
                                                                    checked={checkSelect({
                                                                      menuFirstId,
                                                                      menuSecondId: msId,
                                                                      menuThirdId: null
                                                                    })}
                                                                    onChange={e =>
                                                                      handleCheckMenu(e, {
                                                                        menuFirstId,
                                                                        menuSecondId: msId,
                                                                        menuThirdId: null
                                                                      })
                                                                    }
                                                                  />
                                                                </Grid>
                                                              );
                                                            }
                                                            if (
                                                              checkPackage(
                                                                _.includes(PACKAGE_ADDONS, menuThirdKey)
                                                                  ? menuThirdKey
                                                                  : ''
                                                              )
                                                            ) {
                                                              return (
                                                                <Grid item key={menuThirdId} md={6} sx={{ width: '100%', label: { ml: 0 }, ml: 0 }}>
                                                                  <CheckboxButton
                                                                    key={menuThirdId}
                                                                    label={
                                                                      menuThirds[menuThirdKey]
                                                                        ? t(menuThirds[menuThirdKey].textName)
                                                                        : 'NO_Name'
                                                                    }
                                                                    checked={checkSelect({
                                                                      menuFirstId,
                                                                      menuSecondId: msId,
                                                                      menuThirdId
                                                                    })}
                                                                    onChange={e =>
                                                                      handleCheckMenu(e, {
                                                                        menuFirstId,
                                                                        menuSecondId: msId,
                                                                        menuThirdId
                                                                      })
                                                                    }
                                                                  />
                                                                </Grid>
                                                              );
                                                            }
                                                          }
                                                        )}
                                                      </Grid>
                                                    </Box>
                                                  </Box>
                                                  <Divider sx={{ mx: 0, mt: 2, mb: 3, backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important`, display: indexSecound + 1 === mSnds.length ? 'none' : 'block' }} />
                                                </Grid>
                                              );
                                            }
                                            return (
                                              <Grid item xs={12} sm={menuFirsts[menuFirstKey]?.name === 'Setting' ? 6 : 12} key={menuSecondId} sx={{ width: '100%', display: 'flex', flexDirection: 'column', padding: { xl: '0 32px !important' }, '&:last-child hr': { display: 'none' } }} >
                                                <Box sx={{ mb: 'auto' }}>
                                                  <Typography sx={{ mt: 1, mb: 1, color: colors.themeMainColor, fontWeight: 500 }}>
                                                    {menuSeconds[menuSecondKey]
                                                      ? t(menuSeconds[menuSecondKey].textName)
                                                      : 'NO_Name'}
                                                  </Typography>
                                                  <Box sx={{ padding: { xl: '0 16px !important' } }}>
                                                    <Grid container spacing={1}>
                                                      {_.map(
                                                        _.sortBy(mTrds, ['menuThirdSorting']),
                                                        ({ menuThirdId, menuThirdKey }) =>
                                                          checkPackage(
                                                            _.includes(PACKAGE_ADDONS, menuThirdKey)
                                                              ? menuThirdKey
                                                              : ''
                                                          ) && (
                                                            <Grid item key={menuThirdId} md={12} sx={{ width: '100%', ml: 2, display: menuThirdKey === 'CURRENCY' ? 'none' : 'block' }} >
                                                              <CheckboxButton
                                                                key={menuThirdId}
                                                                label={
                                                                  menuThirds[menuThirdKey]
                                                                    ? t(menuThirds[menuThirdKey].textName)
                                                                    : 'NO_Name'
                                                                }
                                                                checked={checkSelect({
                                                                  menuFirstId,
                                                                  menuSecondId,
                                                                  menuThirdId
                                                                })}
                                                                onChange={e =>
                                                                  handleCheckMenu(e, {
                                                                    menuFirstId,
                                                                    menuSecondId,
                                                                    menuThirdId
                                                                  })
                                                                }
                                                              />
                                                            </Grid>
                                                          )
                                                      )}
                                                    </Grid>
                                                  </Box>
                                                </Box>
                                                <Divider sx={{ mx: 0, mt: 2, mb: 3, backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important`, display: indexSecound + 1 === mSnds.length ? 'none' : 'block' }} />
                                              </Grid>
                                            );
                                          }
                                        }
                                      )}
                                    </Grid>
                                    <Divider sx={{ display: indexFirstKeyNumber + 2 >= menus.length ? 'none' : 'block', mx: 0, mt: 2, backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                                  </Grid>
                                ]
                              )}
                            </>
                          )
                      })}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box >
        </Box >
      </Box >
      <Loading show={loading || loadingPermiss} type={'fullLoading'} />
    </Box >
  )
}
